var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9697 17.0303C16.2626 17.3232 16.7374 17.3232 17.0303 17.0303C17.3232 16.7374 17.3232 16.2626 17.0303 15.9697L15.9697 17.0303ZM14.75 8.1875H14C14 11.3977 11.3977 14 8.1875 14V14.75V15.5C12.2261 15.5 15.5 12.2261 15.5 8.1875H14.75ZM8.1875 14.75V14C4.97734 14 2.375 11.3977 2.375 8.1875H1.625H0.875C0.875 12.2261 4.14892 15.5 8.1875 15.5V14.75ZM1.625 8.1875H2.375C2.375 4.97734 4.97734 2.375 8.1875 2.375V1.625V0.875C4.14892 0.875 0.875 4.14892 0.875 8.1875H1.625ZM8.1875 1.625V2.375C11.3977 2.375 14 4.97734 14 8.1875H14.75H15.5C15.5 4.14892 12.2261 0.875 8.1875 0.875V1.625ZM16.5 16.5L17.0303 15.9697L13.3662 12.3055L12.8359 12.8359L12.3055 13.3662L15.9697 17.0303L16.5 16.5Z",
    fill: "#808191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.3a41c875552d4fa3c802da015ef35254.svg";
export { ForwardRef as ReactComponent };